import React from 'react';
import { useIntl } from 'react-intl';

import Icon from '@/components/Base/Icon';
import {
  Table,
  TableWrapper,
  Td,
  Th,
  Thead,
  Tr,
} from '@/components/Base/StaticContent/ConditionsTable/ConditionsTable.styles';
import ContactUs from '@/components/Base/StaticContent/ContactUs';
import {
  StaticContentText,
  StaticContentTitle,
} from '@/components/Base/StaticContent/StaticContent.styles';

import {
  BlockWrapper,
  StaticContentTitleStyled,
  StyledItem,
  Wrapper,
} from './Information.styles';

export function Information() {
  const { formatMessage } = useIntl();

  const itemWithMinus = (chunks) => (
    <StyledItem>
      <Icon width="16" name="minusIcon" />

      <span>{chunks}</span>
    </StyledItem>
  );

  const h4 = (chunks) => (
    <StaticContentTitleStyled as="h4">{chunks}</StaticContentTitleStyled>
  );

  return (
    <Wrapper id="information" className="sections">
      <BlockWrapper>
        <StaticContentTitle as="h2">
          {formatMessage({
            id: 'staticContent.anchorLinks.map.title.information',
          })}
        </StaticContentTitle>

        <StaticContentText>
          {formatMessage(
            { id: `staticContent.information.information.text` },
            { item: itemWithMinus }
          )}
        </StaticContentText>

        <StaticContentText>
          {formatMessage(
            { id: `staticContent.information.importantNote.text` },
            { item: itemWithMinus, h4 }
          )}
        </StaticContentText>
      </BlockWrapper>

      <BlockWrapper id="whatAreBusinessLoans" className="sections">
        <StaticContentTitle as="h3">
          {formatMessage({
            id: 'staticContent.information.whatAreBusinessLoans.title',
          })}
        </StaticContentTitle>

        <StaticContentText>
          {formatMessage(
            { id: `staticContent.information.whatAreBusinessLoans.text` },
            { h4 }
          )}
        </StaticContentText>
      </BlockWrapper>

      <BlockWrapper id="stepByStepInstructions" className="sections">
        <StaticContentTitle as="h3">
          {formatMessage({
            id: 'staticContent.information.stepByStepInstructions.title',
          })}
        </StaticContentTitle>

        <StaticContentText>
          {formatMessage(
            { id: `staticContent.information.stepByStepInstructions.text` },
            { h4, item: itemWithMinus }
          )}
        </StaticContentText>
      </BlockWrapper>

      <BlockWrapper className="sections">
        <StaticContentTitle as="h3">
          {formatMessage({
            id: 'staticContent.information.loanRejectionReasons.title',
          })}
        </StaticContentTitle>

        <StaticContentText>
          {formatMessage(
            { id: 'staticContent.information.loanRejectionReasons.text' },
            { h4, item: itemWithMinus }
          )}
        </StaticContentText>
      </BlockWrapper>

      <BlockWrapper className="sections">
        <StaticContentTitle as="h3">
          {formatMessage({
            id: 'staticContent.information.chooseBestLoan.title',
          })}
        </StaticContentTitle>

        <StaticContentText>
          {formatMessage(
            { id: 'staticContent.information.chooseBestLoan.text' },
            { h4, item: itemWithMinus }
          )}
        </StaticContentText>
      </BlockWrapper>

      <BlockWrapper className="sections">
        <StaticContentTitle as="h3">
          {formatMessage({
            id: 'staticContent.information.creditRisksBusiness.title',
          })}
        </StaticContentTitle>

        <StaticContentText>
          {formatMessage(
            { id: 'staticContent.information.creditRisksBusiness.text' },
            { h4, item: itemWithMinus }
          )}
        </StaticContentText>

        <StaticContentText>
          {formatMessage(
            { id: 'staticContent.information.creditRisksBusiness.description' },
            { h4 }
          )}
        </StaticContentText>
      </BlockWrapper>

      <BlockWrapper className="sections">
        <StaticContentTitle as="h3">
          {formatMessage({
            id: 'staticContent.information.loanCalculationExamples.title',
          })}
        </StaticContentTitle>

        <StaticContentText>
          {formatMessage(
            { id: 'staticContent.information.loanCalculationExamples.text' },
            { h4, item: itemWithMinus }
          )}
        </StaticContentText>
      </BlockWrapper>

      <BlockWrapper className="sections">
        <StaticContentTitle as="h3">
          {formatMessage({
            id: 'staticContent.anchorLinks.map.title.comparisonTable',
          })}
        </StaticContentTitle>

        <TableWrapper>
          <Table className="staticTable">
            <Thead>
              <Tr>
                <Th>
                  {formatMessage({
                    id: `staticContent.comparisonTable.loanType`,
                  })}
                </Th>

                <Th>
                  {formatMessage({
                    id: `staticContent.comparisonTable.advantages`,
                  })}
                </Th>

                <Th>
                  {formatMessage({
                    id: `staticContent.comparisonTable.disadvantages`,
                  })}
                </Th>

                <Th>
                  {formatMessage({
                    id: `staticContent.comparisonTable.bestPurposeFor`,
                  })}
                </Th>
              </Tr>
            </Thead>

            <tbody>
              {Array.from({ length: 5 }).map((row, index) => (
                <Tr key={index}>
                  <Td>
                    {formatMessage({
                      id: `staticContent.comparisonTable.loanType.${index}`,
                    })}
                  </Td>

                  <Td>
                    {formatMessage({
                      id: `staticContent.comparisonTable.advantages.${index}`,
                    })}
                  </Td>

                  <Td>
                    {formatMessage({
                      id: `staticContent.comparisonTable.disadvantages.${index}`,
                    })}
                  </Td>

                  <Td>
                    {formatMessage({
                      id: `staticContent.comparisonTable.bestPurposeFor.${index}`,
                    })}
                  </Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
      </BlockWrapper>

      <ContactUs />
    </Wrapper>
  );
}

export default Information;
